import Link from "next/link";
import React, { FC } from "react";
import SkeletonImage from "src/components/UserInterface/Skeleton/SkeletonImage";
import { getImageUrl } from "src/utils/magnolia";
import UseWindowSize from "src/components/UseWindowSize";
import { useGetMagnoliaBanner } from "src/core/hooks/useGetMagnoliaBanner";

type MonetizationBannerProps = {
  containerMargin?: string[];
  titleFontSize?: string[];
  titleMargin?: string[];
  bannerRadius?: string[];
  titleTextAlign?: string;
  gap?: string[];
};

export const MonetizationBanner: FC<MonetizationBannerProps> = ({
  containerMargin = ["auto", "auto"],
  titleFontSize = ["20px", "34px"],
  titleMargin = ["unset", "unset"],
  bannerRadius = "16px",
  titleTextAlign = "center",
  gap = ["16px", "24px"]
}) => {
  const { width } = UseWindowSize();
  const { dataBanner, isBannerLoading } = useGetMagnoliaBanner('HCIFormulir')
  const src = width > 600 ? getImageUrl(dataBanner[0]?.bannerDesktop) : getImageUrl(dataBanner[0]?.bannerMobile)

  return (
    <React.Fragment>
      <div className="monetization-banner-container">
        <div className="monetization-banner-title">Penawaran Kami</div>
        {isBannerLoading ? (
          <div className="monetization-banner-loader">
            <SkeletonImage height="250px" src={null} alt="Loading..." />
          </div>
        ) : (
          <Link href={dataBanner[0]?.slugDesktop} legacyBehavior>
            <div className="monetization-banner-img">
              <SkeletonImage height={src ? 'auto' : '250px'} src={src} alt="Monetization Banner" />
            </div>
          </Link>
        )}
      </div>
      <style jsx>{`
        .monetization-banner-loader {
          border-radius: 16px;
        }
        .monetization-banner-container {
          display: flex;
          flex-direction: column;
          gap: ${gap[0]};
          // margin: 16px 16px 0;
          margin: ${containerMargin[0]};
        }

        .monetization-banner-title {
          font-family: Roboto;
          font-size: ${titleFontSize[0]};
          font-weight: 700;
          line-height: 24px;
          letter-spacing: -0.1599999964237213px;
          text-align: ${titleTextAlign};
          margin: ${titleMargin[0]};
        }

        .monetization-banner-img {
          display: flex;
          width: 100%;
          height: auto;
          cursor: pointer;
          border-radius: ${bannerRadius[0]};
        }

        @media only screen and (min-width: 600px) {
          .monetization-banner-loader {
            width: 60vw;
            max-width: 800px;
          }
          .monetization-banner-container {
            display: flex;
            flex-direction: column;
            gap: ${gap[1]};
            margin: 48px auto 0;
            margin: ${containerMargin[1]};
          }

          .monetization-banner-title {
            font-family: Roboto;
            font-size: ${titleFontSize[1]};
            font-weight: 700;
            line-height: 48px;
            letter-spacing: -0.3199999928474426px;
            text-align: ${titleTextAlign};
            margin: ${titleMargin[1]};
          }

          .monetization-banner-img {
            width: 940px;
            border-radius: ${bannerRadius[1]};
          }
        }
      `}</style>
    </React.Fragment>
  );
};
